import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Portal } from "../Portal";

import { useMediaQuery, breakpoints } from "../hooks/useMediaQuery";

const StickyPortal = forwardRef(
  (
    {
      children,
      topAligningElementRef,
      bottomAligningElementRef,
      node,
      portalless,
    },
    ref
  ) => {
    const isMinViewportM = useMediaQuery(`(min-width: ${breakpoints.m}px)`);
    const PortalTag = portalless ? "div" : Portal;

    return (
      <PortalTag ref={ref} node={node}>
        {children({
          stickyDirection: isMinViewportM ? "top" : "bottom",
          aligningElementRef: isMinViewportM
            ? topAligningElementRef
            : bottomAligningElementRef,
        })}
      </PortalTag>
    );
  }
);

StickyPortal.propTypes = {
  children: PropTypes.func.isRequired,
  topAligningElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current:
        typeof Element !== "undefined"
          ? PropTypes.instanceOf(Element)
          : PropTypes.number,
    }),
  ]).isRequired,
  bottomAligningElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current:
        typeof Element !== "undefined"
          ? PropTypes.instanceOf(Element)
          : PropTypes.number,
    }),
  ]).isRequired,
  node: PropTypes.instanceOf(
    typeof Element === "undefined" ? () => {} : Element
  ),
  portalless: PropTypes.bool,
};

StickyPortal.defaultProps = {
  node: typeof document === "undefined" ? null : document.body,
  portalless: false,
};

StickyPortal.displayName = "StickySalesBar.Portal";

export default StickyPortal;
